<script setup lang="ts">
/**
 * GridCard —— 单卡 = `GridItem` + 可选右对齐 footer slot（F12）。
 *
 * `ProblemSection` / `MethodSection` 复用：`GridItem` 提供 `.scu-grid-item`
 * 卡片视觉（▶ marker + h4 标题 + p 摘要 + hover 上移/边框）。footer slot
 * 仅在调用方传入内容时渲染，避免模板卡片底部出现额外空行。
 *
 * 区别于 `InnovationSection` 直接用 `GridItem`（创新点卡片带 cover +
 * RichText 全文，无「更多+」）——GridCard 专给"摘要 + 更多+"卡片形态。
 */
import { computed, useSlots } from 'vue';

import GridItem from './GridItem.vue';

defineProps<{
  readonly title?: string | null;
  readonly summary?: string | null;
  readonly showDraftBadge?: boolean;
}>();

const slots = useSlots();
const hasFooter = computed(() => Boolean(slots.default));
</script>

<template>
  <GridItem
    :title="title"
    :summary="summary"
    :show-draft-badge="showDraftBadge"
  >
    <div v-if="hasFooter" :class="$style.footer">
      <slot />
    </div>
  </GridItem>
</template>

<style module>
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--space-2);
}
</style>
